import { CohortScopeProps } from '../../types/buttons.type';
import customIcons from '../../utils/icons';
import Button from '../buttons/baseButton';
import Chip from '../chip';
import RadioButton from './RadioButton';

export default function CohortSelector(
  {
    cohorts,
    selectedCohort,
    setSelectedCohort,
    deleteCohort,
  }: {
    cohorts: CohortScopeProps[],
    selectedCohort: string,
    setSelectedCohort: (cohort: string) => void | Promise<void>,
    deleteCohort: (cohortId: string) => void | Promise<void>
  },
) {
  return (
    <div className="flex flex-col gap-4 max-h-80 overflow-y-scroll scrollbar-hover">
      <span className="text-xs font-semibold text-piptext-chart whitespace-nowrap">Saved filter presets</span>
      {
                    cohorts.length > 0 ? (
                      cohorts.map((cohort) => (
                        <RadioButton
                          key={cohort.id}
                          value={cohort.id}
                          name="saved-cohort"
                          label={cohort.name}
                          checked={selectedCohort === cohort.id}
                          onChange={() => { setSelectedCohort(cohort.id); }}
                        >
                          <div className="flex">
                            <div id={`cohort-details-container-${cohort.id}`}>
                              <div className="flex flex-wrap gap-2">
                                {cohort.tags.map((tag) => (
                                  <Chip
                                    key={tag}
                                    text={tag}
                                    closeButton={false}
                                    colour="bg-pie-chart-slice2"
                                  />
                                ))}
                              </div>
                              <div className="flex items-center gap-1 text-sm text-piptext-strong">
                                <span>{cohort.formattedStart}</span>
                                <span>&rarr;</span>
                                <span>{cohort.formattedEnd}</span>
                              </div>
                              <div className="text-xs text-piptext-strong mt-1">{cohort.savedOn}</div>
                            </div>
                            <Button
                              id={`delete-cohort-${cohort.id}`}
                              icon={customIcons.trashIcon}
                              ariaLabel={`Delete cohort ${cohort.name}`}
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                deleteCohort(cohort.id);
                              }}
                              className="text-pipstatus-alert text-2xl ml-auto hover:bg-red-50"
                            />
                          </div>
                        </RadioButton>
                      ))
                    ) : (
                      <div className="flex justify-center items-center text-piptext-body">
                        No saved presets yet. Select a campaign or paste household references filter and click save.
                      </div>
                    )
                  }
    </div>
  );
}
